<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ChannelIcon from 'dashboard/components-next/icon/ChannelIcon.vue';

const props = defineProps({
  channel: { type: Object, required: true },
  connectedInbox: { type: Object, default: null },
});

defineEmits(['connect']);

const { t } = useI18n();

const connected = computed(() => Boolean(props.connectedInbox));
// Prefer the real connected account's name over the detected handle — the user
// may have connected a different account than the one we detected.
const connectedName = computed(
  () =>
    props.connectedInbox?.name ||
    props.channel.handle ||
    t(props.channel.labelKey)
);
</script>

<template>
  <div class="flex flex-wrap items-center gap-3 border-b border-n-weak p-3">
    <div
      class="flex size-9 shrink-0 items-center justify-center rounded-xl bg-slate-25"
    >
      <ChannelIcon :inbox="channel.inbox" use-brand-icon class="size-5" />
    </div>
    <span class="flex-1 min-w-0 truncate text-body-main text-n-slate-12">
      {{ t(channel.labelKey) }}
    </span>
    <div
      v-if="connected"
      class="flex w-full min-w-0 flex-wrap items-center gap-2 text-xs text-n-slate-11 sm:w-auto"
    >
      <span class="min-w-0 break-all">{{ connectedName }}</span>
      <span class="w-px h-3 bg-n-weak" />
      <span class="whitespace-nowrap">
        {{ t('ONBOARDING_INBOX_SETUP.CHANNELS.CONNECTED') }}
      </span>
    </div>
    <button
      v-else
      type="button"
      class="flex min-h-11 shrink-0 items-center rounded-lg border border-slate-100 bg-white px-3 text-xs font-medium text-slate-900 transition-colors hover:border-woot-600 hover:bg-woot-25 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-woot-600"
      @click="$emit('connect', channel)"
    >
      <span class="truncate">
        {{ t('ONBOARDING_INBOX_SETUP.CHANNELS.CONNECT') }}
      </span>
    </button>
  </div>
</template>
